<template>
  <div class="form-group">
    <label
      v-bind:class="{
        'text-danger': current.errors && current.errors.proveedor,
      }"
      >Ruta Reparto</label
    >
    <v-select
      label="nombre"
      v-model="current.ruta_reparto"
      :disabled="disabled"
      @input="onChangeRuta($event)"
      :filterable="false"
      :options="rutas"
      @search="onSearch"
    >
      <template slot="no-options">Rutas...</template>
      <template slot="option" slot-scope="option">
        <div class="selected d-center">
          {{ option.id }} - {{ option.nombre }}
        </div>
      </template>
      <template slot="selected-option" slot-scope="option">
        <div class="selected d-center">
          {{ option.id }} - {{ option.nombre }}
        </div>
      </template>
    </v-select>
    <small
      v-if="current.errors && current.errors.proveedor"
      class="form-text text-danger"
      >{{ current.errors.proveedor }}</small
    >
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";

export default {
  props: ["current", "disabled"],
  data() {
    return {
      rutas: [],
    };
  },
  computed: {},
  mounted() {
    this.refreshData();
  },
  methods: {
    refreshData() {
      let self = this;
      DynamicService.fetch("cat", "ruta-reparto", {
        page: 1,
      }).then((res) => {
        self.rutas = res.data.results;
      });
    },
    onChangeRuta(event) {
      this.$emit("onChangeCliente", event);
    },
    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },
    search: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      DynamicService.fetch("cat", "ruta-reparto", {
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search,
      }).then((res) => {
        vm.rutas = res.data;
        loading(false);
      });
    }, 350),
  },
};
</script>0
